const raqDataLayerPushFactory = (data?: any, sourceUrl?: string) => ({
  event: "dataLayerPush",
  formData: {
    Location: sourceUrl ?? "",
    Name: "Request a Quote",
    Type: "Nextjs",
    firstname: data?.firstName ?? "",
    lastname: data?.lastName ?? "",
    email: data?.email ?? "",
    phone: data?.phone ?? "",
    "yes i would like to receive email offers travel tips and destination information": data?.optInEmail?.toString() ?? "",
    "yes i am a travel professional": data?.isTravelAgent?.toString() ?? "",
    "yes i am traveling with 8 or more people": data?.withMoreTravelers?.toString() ?? "",
    "yes i am working with a travel professional": data?.workingWithAgent?.toString() ?? "",
    tourId: data?.tourId ?? "",
    tourDepartureDate: data?.tourDepartureDate ?? ""
  }
});

export default raqDataLayerPushFactory;